import { render, staticRenderFns } from "./HeaderDropdownNotif.vue?vue&type=template&id=6470f7e6"
import script from "./HeaderDropdownNotif.vue?vue&type=script&lang=js"
export * from "./HeaderDropdownNotif.vue?vue&type=script&lang=js"
import style0 from "./HeaderDropdownNotif.vue?vue&type=style&index=0&id=6470f7e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports